import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import OverviewSection from './components/OverviewSection';
import HighlightedLabsSection from './components/HighlightedLabsSection';
import PracticeResourcesSection from './components/PracticeResourcesSection';
import InteractiveLabsSection from './components/InteractiveLabsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

const HomePage = () => (
  <div className="min-h-screen">
    <Navbar />
    <HeroSection />
    <OverviewSection />
    <HighlightedLabsSection />
    <PracticeResourcesSection />
    <InteractiveLabsSection />
    <ContactSection />
    <Footer />
  </div>
);

export default HomePage;
